export default __webpack_public_path__ + "static/media/work.4b56f4c2.jpeg";